export const DisplayTypes = {
	STRING: "string",
	INTEGER: "int",
	DECIMAL: "decimal",
	DATE: "date",
	DATETIME: "datetime",
}